import { View } from "react-native";
import { useEffect } from "react";
import { useRouter } from "@/_router";
import { getBasePath } from "@/models/utils";
import { initPostHog } from "@/fetchData/posthog";
import { isNativeApp } from "@/models/platform";
import { useAuth } from "@/models/useAuth";

export default function WebApp() {
  const router = useRouter();

  useEffect(() => {
    const handleRouting = async () => {
      initPostHog();

      if (isNativeApp() && !useAuth.isAuthenticated()) {
        router.replace(`${getBasePath()}/onboarding`);
      } else {
        router.replace(`${getBasePath()}/home`);
      }
    };

    handleRouting();
  }, []);

  return <View />;
}
